import React from 'react';
import { useIntl } from 'react-intl';

import { BusinessVerificationRoutes } from 'modules/compliance';

import StepPageWrapper from '../components/StepPageWrapper';
import { BASE_STEPS_PREVIEW_INTL_ID } from '../components/StepsPreview/constants';
import { SsmoStepsIdentifiers, SsmoTask } from '../constants';

export const KybPage = () => {
  const { formatMessage } = useIntl();

  return (
    <StepPageWrapper
      title={formatMessage({ id: `${BASE_STEPS_PREVIEW_INTL_ID}.build-partnership.tasks.verify-business.title` })}
      step={SsmoStepsIdentifiers.KybDataSubmition}
      task={SsmoTask.KYB}
    >
      <BusinessVerificationRoutes />
    </StepPageWrapper>
  );
};
